// Franja del cliente bajo la topbar en los 10 pasos: nombre (cuando el KYC lo da) y teléfono del paso 01.
// Con SureKeep confirmado suma el chip de nivel, que aplica a todos los pasos.
import { formatPhone } from '../phoneFormat';
import { isSureKeepConfirmed } from '../sureKeepAvailability';
import type { WizardSession } from '../types';
import { LevelChip } from './LevelChip';

export function WizardClientBar({ session }: { session: WizardSession }) {
    const clientName = session.kyc.verified?.fullName ?? session.firstName;

    return (
        <div className="flex flex-none items-center gap-2 border-b border-border bg-card px-3 py-1.5 sm:px-5">
            <span className="flex-none text-[10px] font-semibold uppercase tracking-[0.08em] text-muted-foreground">
                Cliente
            </span>
            {clientName && (
                <>
                    <span className="truncate text-[12px] font-semibold">{clientName}</span>
                    <span className="flex-none text-border">·</span>
                </>
            )}
            <span className="flex-none text-[12px] font-medium tabular-nums">
                {formatPhone(session.phone)}
            </span>
            {isSureKeepConfirmed(session) && (
                <>
                    <span className="flex-none text-border">·</span>
                    <LevelChip level={session.loan?.level} size="sm" />
                </>
            )}
        </div>
    );
}
